
 

(function() {

  // Define our constructor 
  this.wbskFormElements = function() {

    // Create global element references


    // Define option defaults 
    const defaults = {
      nodes:false
    }
 

    // Create options by extending defaults with the passed in arugments
    if (arguments[0] && typeof arguments[0] === "object") {
      this.options = Object.assign({}, defaults, arguments[0]);
      //this.options_init = JSON.parse(JSON.stringify(this.options))
    }
    
    this.init()
  }

  // Public Methods
   wbskFormElements.prototype.init = function() {

     // get the wrapper dom element
    this.options.element = typeof this.options.element === 'string' ? document.querySelectorAll(this.options.element)[0] : this.options.element
    
    // assign random ids to the nodes
    this.options.id = randomBigInt()
    if(this.options.primary){
      this.options.primary.id = randomBigInt()
    }
    this.options.nodes = !this.options.nodes ? [] : this.options.nodes.map(node => {
      node.id = randomBigInt()
      if(this.options.primary  && node.options.length > 1 && !this.options.primary.hasChildOptions){
        this.options.primary.hasChildOptions = true
      }
      if(node.value){
        node.selected_option = node.options.filter(option => option.value == node.value)[0]
      }
      // get the categories
      let categories = !node.options || !node.options.length ? false : node.options.map( option => option.category).filter(cat => cat)
      categories = !categories.length ? false : [... new Set(categories) ]
      if(categories){
        let selected = node.value ? node.options.findIndex( item => item.value == node.value) : false
        selected = selected ? node.options[selected].category : false   
        node.categories = {
          selected:selected,
          options:categories
        }
      }
      return node
    })

    const template = generateTemplate(this)
    this.options.element.innerHTML = template
    
    // bind the template
    bindTemplate(this)
    
    //init swipers
    const swipers = this.options.nodes.filter(node => node.swiper)
    if(swipers.length){
      initSwipers(swipers,this)
    }

     
    wbskFormElements.instances = wbskFormElements.instances ? wbskFormElements.instances.filter( instance => document.contains(instance.options.element)) : []
    wbskFormElements.instances.push(this)
  }

  wbskFormElements.prototype.closeNodes = function() {
    if(this.options.primary && this.options.primary.nodeToggle){
      this.options.primary.nodeToggle.open = false
    }
    if(this.options.nodesWrapper){
      this.options.nodesWrapper.classList.remove('wbsk-fe-nodes-wrapper--open')
    }
  }


  wbskFormElements.prototype.toggleNodesVisibilty = function(open) {
    if(wbskFormElements.instances){
      wbskFormElements.instances.forEach( instance => {
        if(instance.options.id != this.options.id){
          instance.closeNodes()
        }
      })
    }
    const primaryNode =  this.options.primary
    if(primaryNode && primaryNode.hasChildOptions){
      open = open == 'true' ? true : open == 'false' ? false : open
      this.options.primary.nodeToggle.open = open != null ? open : !this.options.primary.nodeToggle.open

      if(this.options.primary.nodeToggle.open){
        this.options.nodesWrapper.classList.add('wbsk-fe-nodes-wrapper--open')
      }else{
        this.options.nodesWrapper.classList.remove('wbsk-fe-nodes-wrapper--open')
      }
      const event = new CustomEvent('toggleNodesVisibilty' , {bubbles: true});
      this.options.nodesWrapper.dispatchEvent(event);
    }
  }
  
  wbskFormElements.prototype.toggleCategoryVisibility = function(node) {
    const items = node.element.querySelectorAll(`[data-wbskcategory]`)
    Object.values(items).forEach((item,index) => {
      const catgory = item.getAttribute('data-wbskcategory')
      item.style.display = catgory == node.categories.selected ? 'block' : 'none' 
    })
    if(node.swiper && node.swiper.jsSwiper){
      node.swiper.jsSwiper.update()
    } 
  }

  wbskFormElements.prototype.getNodeByKey = function(key) {
    let node = this.options.nodes.filter(node => node.key == key)
    return node.length ? node[0] : false
  }

  wbskFormElements.prototype.updateNodeOptions = function(node) {
    const _this = this
    return new Promise( function(resolve,reject){
      node.init = false
      node.element.innerHTML = generateNode(node)
      bindNodes(_this)
      if(node.swiper && node.swiper.jsSwiper){
        node.swiper.jsSwiper.destroy(true,true)
        initSwipers([node],_this)
      }
      let valueUpdated = false
      const nodeOptionValues = node.options.map( option => option.value)
      if(nodeOptionValues.indexOf(node.value) < 0 ){
        simulateClick(node.options[0].input)
        valueUpdated = true
      }
      resolve(valueUpdated)

    })
  }

  wbskFormElements.prototype.updatePrimaryControl = function(node){
    const primaryNode = this.options.primary
    if(node.updatesPrimary){
      primaryNode.value = node.value
      primaryNode.element.setAttribute('data-value', node.selected_option && node.selected_option.value_label ? node.selected_option.value_label : node.value )
      primaryNode.element.classList.remove('wbsk-fe-selectToggle-control--pristine')
    }
    primaryNode.hasChildOptions = node.options.length > 1
    if(primaryNode.hasChildOptions){
      primaryNode.element.classList.remove('wbsk-fe-selectToggle-control--no-options')
    }else{
      primaryNode.element.classList.add('wbsk-fe-selectToggle-control--no-options')
    }
    if(primaryNode.showImageInSelect){
      if(node.selected_option && node.selected_option.image){
        primaryNode.element.classList.add('wbsk-fe-selectToggle-control--with-img')
        primaryNode.showImageInSelect.style.background = `url('${node.selected_option.image}')`
      }else{
        primaryNode.element.classList.remove('wbsk-fe-selectToggle-control--with-img')
      }
    }
    if(primaryNode.onChange && typeof primaryNode.onChange === "function"){
      primaryNode.onChange(primaryNode)
    }
  }

  // Private Methods
  const randomBigInt = () => {
    return `wbskFormElements${Math.floor(Math.random()*100000000000000000)}`
  }

  
  const generateTemplate = (_this) => {
    return  `
     <div class="wbsk-fe-wrapper">
      ${_this.options.primary ? `
       <div class="wbsk-fe-primary">
	     <label class="wbsk-fe-primary__label">${_this.options.label}</label>
         <div class="wbks-fe-primary__control-wrapper">
           ${generateNode(_this.options.primary)}
         </div>
       </div>
       ` : '' }
       ${ _this.options.nodes && _this.options.nodes.length ? 
       `<div class="wbsk-fe-nodes-wrapper ${!_this.options.primary ? 'wbsk-fe-nodes-wrapper--no-primary' : ''}">
         ${gererateChildNodes(_this.options.nodes)}
       </div>` :'' 
       }
     </div>    
     `
  }
  
  const gererateChildNodes = (nodes) => {
    const nodeTemplates = []
    nodes.forEach(node => {
      nodeTemplates.push(generateNode(node))
    })
    return nodeTemplates.join('')
  }
  

  const generateNode = (node) => {
    let template = false
    if(node.type == 'selectToggle'){
      template = `
        <div class="wbsk-fe-selectToggle-control ${ node.showImageInSelect ? 'wbsk-fe-selectToggle-control--with-img' : '' } wbsk-fe-selectToggle-control--pristine" 
             data-wbskControlId="${node.id}" 
             data-pristine="" data-open="">
             ${ node.showImageInSelect ? `<span class="wbsk-fe-selectToggle-control__img"></span>` : ''}
        </div>`
    }
    
    if(node.type == 'edit_toggle'){
        template = `  
          <div class="wbsk-fe-editToggle-control"> 
            <span>${node.value}</span>
            <button class="wbsk-fe-editToggle-control__button" data-wbskControlId="${node.id}">Edit</button>
          </div>
        `
    }
    
    
    if(node.type == 'button_toggle'){
        template = `  
        <ul class="${ node.swiper ? 'swiper-wrapper' : 'wbsk-fe-flex-controls-wrapper'}">
           ${node.options.map( (option,index) => {
          return `<li ${option.category ? `data-wbskCategory="${option.category}"` :'' } 
                      class="${node.swiper ? 'swiper-slide' : 'wbsk-fe-flex-controls-item'} ${node.styles.listClass}">
                 <label class="wbsk-fe-proxy-radio">
                   <input class="wbsk-fe-proxy-radio__input" 
                          name="${node.id}" 
                          data-wbskControlId="${node.id}" 
                          value="${option.value}" 
                          type="radio" ${node.value && node.value == option.value ? 'checked' : ''}> 
                   <div class="wbsk-fe-proxy-radio__content">
                     ${node.styles.thumbnail ? 
                      `<span class="wbsk-fe-proxy-radio__thumb-img ${!option.image ? 'wbsk-fe-proxy-radio__thumb-img--no-src' : ''}">
                        ${option.image ? `<img src="${option.image}">` : '' }
                       </span>
                       <span>${option.value_label ? option.value_label : option.value}</span>` : `<span class="wbsk-fe-proxy-radio__button">${option.value_label ? option.value_label : option.value}</span>`}
                   </div>
                 </label>
               </li>
             `
           }).join('')}
          </ul>
        `
      if(node.swiper){
        template = `<div data-wbskControlSwiperId="${node.id}" class="swiper-container wbsk-fe-flex-swiper-container">${template}</div>`
      }
      template = `${node.categories && node.categories.options.length ? `${getNodeCetegoryNavTemplate(node)}` : ''} ${template}`
    }
    
    if(node.type == 'switchToggle'){
      template = `
        <div class="wbsk-fe-switch-control-wrapper">
          <label class="wbsk-fe-switch-control wbsk-fe-switch-control--left">
            <input class="wbsk-fe-switch-control__input" 
                   type="radio"
                   name="${node.id}" 
                   data-wbskControlId="${node.id}" 
                   value="${node.options[0].value}" 
                   ${node.value != null && node.value == node.options[0].value ? 'checked' : ''}>
            <div class="wbsk-fe-switch-control__switcher">
              <span class="wbsk-fe-switch-control__label">${node.options[0].label}</span>
              <div class="wbsk-fe-switch-control__toggle"></div>
            </div>
          </label>
          <label class="wbsk-fe-switch-control wbsk-fe-switch-control--right">
             <input class="wbsk-fe-switch-control__input" 
                   type="radio"
                   name="${node.id}" 
                   data-wbskControlId="${node.id}" 
                   value="${node.options[1].value}" 
                   ${node.value != null && node.value == node.options[1].value ? 'checked' : ''}>
            <div class="wbsk-fe-switch-control__switcher">
              <div class="wbsk-fe-switch-control__toggle"></div>
              <span class="wbsk-fe-switch-control__label">${node.options[1].label}</span>
            </div>
          </label>
        </div>
      `
    }
    if(node.type == 'sidebarToggle'){
      template = `
        <div class="wbsk-fe-sidebar-control-wrapper">
          <span class="wbsk-fe-sidebar-control-close wbsk-fe-sidebar-control__close-bg"></span>
          <div class="wbsk-fe-sidebar-control-container wbsk-ui-scroll-flex">
            <div class="wbsk-ui-scroll-flex__fixed">
              <div class="block-rel">
                <span class="wbsk-fe-sidebar-control-close wbsk-fe-sidebar-control__close-icon"></span>
                <div class="wbsk-fe-sidebar-control__title">${node.label}</div>
              </div>
            </div>
            <div class="wbsk-ui-scroll-flex__scroll">
              <ul>
              ${node.options.map( (option,index) => {
                return `
                  <li class="wbsk-fe-inline-radio-wrapper">
                    <label class="wbsk-fe-inline-radio">
                      <input class="wbsk-fe-inline-radio__input" 
                             name="${node.id}" 
                             data-wbskControlId="${node.id}" 
                             value="${option.value}" 
                             type="radio" ${node.value && node.value == option.value ? 'checked' : ''}> 
                      <div class="wbsk-fe-inline-radio__content">
                        ${option.image ? `<span class="wbsk-fe-inline-radio__img"><img src="${option.image}" alt="${option.value}"></span>` : ''}
                        <span>${option.value_label ? option.value_label : option.value}</span>
                      </div>
                    </label>
                  </li>
                  `
              }).join('')}
              </ul>
            </div>
          </div>
        </div>
      `

    }
    return `<div data-wbskNodeId="${node.id}">${template}</div>`
  }
  
  const getNodeCetegoryNavTemplate = (node) => {
    return `
      <ul class="wbsk-fe-cat-toggles">
        ${node.categories.options.map( (option,index) => {
          return `
            <li class="wbsk-fe-cat-toggles__item">
              <label class="wbsk-fe-proxy-radio">
                   <input class="wbsk-fe-proxy-radio__input" 
                          name="wbskfeCategory${node.id}" 
                          data-wbskCategoryControlId="${node.id}" 
                          value="${option}" 
                          type="radio" ${node.categories.selected == option || !node.categories.selected && index == 0 ? 'checked' : ''}> 
                   <div class="wbsk-fe-proxy-radio__content">
                     <span class="wbsk-fe-proxy-radio__text">${option}</span>
                   </div>
                 </label>
            </li>
          `
        }).join('')}
      </ul>
    ` 
  }

  
  const bindNodes = (_this) => {
    _this.options.nodes.filter(node => !node.init).forEach( node => {
      node.init = true
      node.element = document.querySelectorAll(`[data-wbskNodeId="${node.id}"]`)[0]
      // update the primary on init
      if(node.value && _this.options.primary){
        _this.updatePrimaryControl(node)     
      }
      if(node.type == 'sidebarToggle'){
        node.element.querySelectorAll('.wbsk-fe-sidebar-control-close').forEach(item => {
          item.addEventListener('click', event => {
            _this.toggleNodesVisibilty()
          })
        })
      }
      const inputs = document.querySelectorAll(`[data-wbskControlId="${node.id}"]`)
      inputs.forEach((input,index) => {
        node.options[index].input = input
              
        // change events for radios
        input.addEventListener('change', (event) => {
          // assign the value to the node
          node.value = event.target.value
          node.selected_option = node.options.filter(option => option.value == node.value)[0]
          // if its a switch toggle that controls visiblity then  fire toggleNodesVisibilty
          if(node.type == 'switchToggle' && node.nodeToggle){
            _this.toggleNodesVisibilty(node.value) 
          }
          // callback function
          if(node.onChange && typeof node.onChange === "function"){
            node.onChange(node)
          }
         // update the primary value and remove the pristine class
          if(node.updatesPrimary){
            _this.updatePrimaryControl(node)
          }

          if(node.closeOnChange){
            _this.toggleNodesVisibilty()  
          }
        })

        // switch toggle
        if(node.type == 'switchToggle'){
          input.addEventListener('click', (event) => {
            if(event.target.value == node.value){
              const siblingIndex = index == 0 ? 1 : 0
              simulateClick(node.options[siblingIndex].input)
            }
          })
        }
        
      })
      
      // category change events toggleCategoryVisibility
      if(node.categories && node.categories.options.length){
        node.categories.selected = node.categories.selected || node.categories.options[0]
        const categoryInputs = document.querySelectorAll(`[data-wbskcategorycontrolid="${node.id}"]`)
        categoryInputs.forEach((input,index) => {
          input.addEventListener('change', (event) => {
            node.categories.selected = event.target.value
            _this.toggleCategoryVisibility(node)
          })
        })
        _this.toggleCategoryVisibility(node)
      }
      
    })
  }
 
  const bindTemplate = (_this) => {
    // get the nodes wrapper
    _this.options.nodesWrapper = _this.options.element.querySelectorAll('.wbsk-fe-nodes-wrapper')[0]
    // bind the primary if isNodeToggle , push it to the nodes array if not
    if(_this.options.primary){
      _this.options.primary.element = document.querySelectorAll(`[data-wbskControlId="${_this.options.primary.id}"]`)[0]
      if(_this.options.primary.type  == 'edit_toggle'){
        _this.options.primary.element.addEventListener('click',(e) => {
           _this.options.primary.onChange(_this.options.primary)
        })
      }
      _this.options.primary.showImageInSelect =  _this.options.primary.showImageInSelect ? _this.options.primary.element.querySelectorAll(`.wbsk-fe-selectToggle-control__img`)[0] : false

      // bind click event to primary if its a select toggle
      if(_this.options.primary.type == 'selectToggle' ){
        _this.options.primary.element.addEventListener('click',(e) => {
          _this.toggleNodesVisibilty()  
        })
        _this.toggleNodesVisibilty(_this.options.primary.nodeToggle.open) 
      }
    
      // if its a switch toggle that controls visiblity then  fire toggleNodesVisibilty
      if(_this.options.primary.type == 'switchToggle' && _this.options.primary.nodeToggle){
        _this.toggleNodesVisibilty(_this.options.primary.value) 
      }
    
      // push primary control to nodes if its a control
      if(_this.options.primary.options){
        _this.options.nodes.push(_this.options.primary)
      }
    }
       
    // bind the nodes
    bindNodes(_this)
  }
  
  const initSwipers = (swipers,_this) => {
    swipers.forEach(node => {
      const swiperEl = document.querySelectorAll(`[data-wbskControlSwiperId="${node.id}"]`)[0]
      node.swiper.jsSwiper= new Swiper(swiperEl,node.swiper)
      // bind to the toggleNodesVisibilty event and updte the swiper
       _this.options.nodesWrapper.addEventListener('toggleNodesVisibilty',(e) => {
         setTimeout( (e) => {
           node.swiper.jsSwiper.update()
         },50)
       })
      
    })
  }
  
  const simulateClick = (elem) => {
	// Create our event (with options)
	const evt = new MouseEvent('click', {
		bubbles: false,
		cancelable: true,
		view: window
	});
	// If cancelled, don't dispatch our event
	const canceled = !elem.dispatchEvent(evt);
};

}());


